import React from 'react'

import type { ShowProps } from './types'

export const Show: React.FC<ShowProps> = ({ condition, fallback, children }) => (
  <>{ condition === true ? children : fallback }</>
)

Show.displayName = 'Show'
